import { render, staticRenderFns } from "./Seminar.vue?vue&type=template&id=30bb2239"
import script from "./Seminar.vue?vue&type=script&lang=js"
export * from "./Seminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports